import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FormGenerator } from '@microservices/wiskey-react-components'

import { PageContext } from '@pages/TimeLineCreateOrEdit/TimeLineCreateOrEdit'

import { CommandParameters } from '@components/CommandParameters'

import { TYPES_SOURCE_OPTIONS } from '@constants'
import { AutocompleteOption } from '@types'

import { ModalRefPathPicker } from '@gantt/components/GanttCreateOrEdit/components/ModalRefPathPicker'

export const ObjectXDateTimeDataTab = () => {
  const { t } = useTranslation()
  const { state, inputs } = useContext(PageContext)

  const { watchObjectXObject, watchObjectXCommandCode } = state

  const { objectXDataInputs } = inputs

  return (
    <>
      <FormGenerator inputs={objectXDataInputs} mainGridSpacing={0} />
      {!!watchObjectXCommandCode && !!watchObjectXObject?.id && (
        <>
          <CommandParameters
            disableFieldType
            commandCode={watchObjectXCommandCode.id}
            containerSx={{ mb: 1 }}
            label={t('contextMenuCreate.addMenuPointModal.parameters.label')}
            labelWidth={120}
            name='objectX.getDataCommand.parameters'
            parametersMode='params'
            sourceCode={watchObjectXObject.id as string}
            sourceTitle={watchObjectXObject.label}
            typeSource={TYPES_SOURCE_OPTIONS.OBJECT}
          />

          <CommandParameters
            disableFieldType
            commandCode={watchObjectXCommandCode.id}
            containerSx={{ mb: 1 }}
            label={t('contextMenuCreate.addMenuPointModal.body.label')}
            labelWidth={120}
            name='objectX.getDataCommand.body'
            parametersMode='body'
            sourceCode={watchObjectXObject.id as string}
            sourceTitle={watchObjectXObject.label}
            typeSource={TYPES_SOURCE_OPTIONS.OBJECT}
          />
        </>
      )}
      {!!watchObjectXObject?.id && (
        <ModalRefPathPicker
          hasClearInInput
          isRequired
          refPickAllowed
          embeddedObjectPickerControllerName={'objectX.linkToObjectY.pathArray'}
          isDisabled={false}
          label={t(`timeLinesCreateOrEdit.objectX.linkToObjectY`)}
          name={'objectX.linkToObjectY.keyField'}
          object={watchObjectXObject as AutocompleteOption<string>}
          pickerName={''}
        />
      )}
    </>
  )
}
